const works = [
  {
    title: "IM Trading",
    description: "АВТО ПОД ЗАКАЗ ИЗ-ЗА РУБЕЖА",
    avatar: "./works/im_trading/avatar.png",
    avatarWebp: "./works/im_trading/avatar.webp",
    images: [
      "./works/im_trading/avatar.png",
      "./works/im_trading/img-1.png",
      "./works/im_trading/img-2.png"
    ],
    imagesWebp: [
      "./works/im_trading/avatar.webp",
      "./works/im_trading/img-1.webp",
      "./works/im_trading/img-2.webp"
    ],
    build: "https://imtrading.ru",
    code: "https://gitlab.com/vays3btro/im-trading",
  },
  {
    title: "Avenue",
    description: "Сайт знакомств для свингеров",
    avatar: "./works/avenue/avatar.png",
    avatarWebp: "./works/avenue/avatar.webp",
    images: [
      "./works/avenue/avatar.png",
      "./works/avenue/img-1.png",
      "./works/avenue/img-2.png",
      "./works/avenue/img-3.png",
      "./works/avenue/img-5.png",
    ],
    imagesWebp: [
      "./works/avenue/avatar.webp",
      "./works/avenue/img-1.webp",
      "./works/avenue/img-2.webp",
      "./works/avenue/img-3.webp",
      "./works/avenue/img-5.webp",
    ],
    build: undefined,
    code: undefined,
  },
  {
    title: "ЛентаВиль",
    description: "Изысканные композиции из атласных лент",
    avatar: "./works/lentavile/avatar.png",
    avatarWebp: "./works/lentavile/avatar.webp",
    images: [
      "./works/lentavile/avatar.png",
      "./works/lentavile/img-1.png",
      "./works/lentavile/img-2.png",
      "./works/lentavile/img-3.png",
    ],
    imagesWebp: [
      "./works/lentavile/avatar.webp",
      "./works/lentavile/img-1.webp",
      "./works/lentavile/img-2.webp",
      "./works/lentavile/img-3.webp",
    ],
    build: "https://lentavil.online/",
    code: "https://gitlab.com/vays3btro/lentavil",
  },
  {
    title: "VDK авто",
    description: "Автомобили с аукционов",
    avatar: "./works/vdk/VDK-img-1.jpg",
    avatarWebp: "./works/vdk/VDK-img-1.webp",
    images: [
      "./works/vdk/VDK-img-1.jpg",
      "./works/vdk/VDK-img-2.jpg",
      "./works/vdk/VDK-img-3.jpg",
      "./works/vdk/VDK-img-4.jpg",
      "./works/vdk/VDK-img-5.jpg",
    ],
    imagesWebp: [
      "./works/vdk/VDK-img-1.webp",
      "./works/vdk/VDK-img-2.webp",
      "./works/vdk/VDK-img-3.webp",
      "./works/vdk/VDK-img-4.webp",
      "./works/vdk/VDK-img-5.webp",
    ],
    build: "https://vdkauto125.ru/",
    code: "https://gitlab.com/vays3btro/cjk_motors",
  },
  // {
  //   title: "CJK Motors",
  //   description: "Автомобили с аукционов",
  //   avatar: "./works/cjkMotors/cjk-img-1.jpg",
  //   avatarWebp: "./works/cjkMotors/cjk-img-1.webp",
  //   images: [
  //     "./works/cjkMotors/cjk-img-1.jpg",
  //     "./works/cjkMotors/cjk-img-2.jpg",
  //     "./works/cjkMotors/cjk-img-3.jpg",
  //     "./works/cjkMotors/cjk-img-4.jpg",
  //     "./works/cjkMotors/cjk-img-5.jpg",
  //   ],
  //   imagesWebp: [
  //     "./works/cjkMotors/cjk-img-1.webp",
  //     "./works/cjkMotors/cjk-img-2.webp",
  //     "./works/cjkMotors/cjk-img-3.webp",
  //     "./works/cjkMotors/cjk-img-4.webp",
  //     "./works/cjkMotors/cjk-img-5.webp",
  //   ],
  //   build: "https://cjkmotors.ru/",
  //   code: "https://gitlab.com/vays3btro/cjk_motors",
  // },
  {
    title: "ФЕНИКС",
    description: "Производственно-строительная компания",
    avatar: "./works/phoenix/phoenix-ava.jpg",
    avatarWebp: "./works/phoenix/phoenix-ava.webp",
    images: [
      "./works/phoenix/phoenix-img-1.jpg",
      "./works/phoenix/phoenix-img-2.jpg",
      "./works/phoenix/phoenix-img-3.jpg",
      "./works/phoenix/phoenix-img-4.jpg",
      "./works/phoenix/phoenix-img-5.jpg",
    ],
    imagesWebp: [
      "./works/phoenix/phoenix-img-1.webp",
      "./works/phoenix/phoenix-img-2.webp",
      "./works/phoenix/phoenix-img-3.webp",
      "./works/phoenix/phoenix-img-4.webp",
      "./works/phoenix/phoenix-img-5.webp",
    ],
    build: "https://pskfenix.ru/",
    code: "https://gitlab.com/vays3btro/psk-phoenix",
  },
]

export default works;
